export const LanguageFormStages = [
  {
    title: "Language",
    sections: [
      {
        name: "",
        fields: [
          {
            name: "g4_name",
            description: "",
            isNameField: true,
            label: "Name",
            required: true,
            type: "nvarchar",
          },
          {
            name: "g4_culturename",
            description: "",
            label: "Culture Name",
            required: true,
            type: "nvarchar",
          },
        ],
      },
    ],
  },
];
